<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-layout--no-pad" :class="{ 'ccs-6': isEditing, 'ccs-12': !isEditing }">
      <ccs-input :class="{ 'ccs-6': !isEditing, 'ccs-12': isEditing }"
        v-model.trim="fieldsValues.name" v-bind="fieldsDefinitions.name"
        @error="(err) => setFieldError('name', err)"/>
      <ccs-input :class="{ 'ccs-6': !isEditing, 'ccs-12': isEditing }"
        v-model.trim="fieldsValues.slug" v-bind="fieldsDefinitions.slug"
        @error="(err) => setFieldError('slug', err)"/>
    </div>
    <div v-if="isEditing" class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-9" v-model="permissionSlug" v-bind="fieldsDefinitions.permissions"
        :items="permissionsForSelect" @change="onPermissionSearch"/>
      <div class="ccs-3 button--add">
        <button class="ccs-button ccs-button--small ccs-12" @click="addPermission">
          Добавить
        </button>
      </div>
      <div class="ccs-layout ccs-12 ccs-layout--scroll role-permissions_list">
        <div class="ccs-tag ccs-tag--normal" v-for="(permission, index) in fieldsValues.permissions" :key="index"
          @click="removePermission(permission)">
          {{ permission.name }}
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Role',
  mixins: [AutocompleteParent, FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Название",
          placeholder: "Введите название",
        },
        slug: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Обозначение",
          placeholder: "Введите обозначение",
        },
        permissions: {
          isValid: false,
          error: '',
          required: false,
          type: "autocomplete",
          label: "Разрешения",
          placeholder: "Введите 3 символа для поиска",
        },
      },
      fieldsValues: {
        name: '',
        slug: '',
        permissions: [],
      },
      permissionSlug: undefined,
      permissionsForSelect: [],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    isEditing() {
      return !!(this.$props.data && this.$props.data.id);
    }
  },
  methods: {
    ...mapActions('users', ['createRole', 'updateRole', 'addPermissionToRole', 'deletePermissionFromRole']),
    async onPermissionSearch(text) {
      [this.permissionsForSelect] = await this.getAutocompleteData('/v1/permissions/list', text,
        'slug');
    },
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        if (this.fieldsValues.id) {
          this.editRole();
        } else {
          this.addRole();
        }
      }
    },
    async addRole() {
      try {
        await this.createRole(this.fieldsValues);
        this.$toasted.success('Роль добавлена');
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async editRole() {
      const changedFields = this.getChangedFields(this.$props.data);
      if (Object.keys(changedFields).length > 0){
        try {
          await this.updateRole(this.fieldsValues);
          this.$toasted.success('Роль изменена');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
    async addPermission() {
      try {
        await this.addPermissionToRole({
          roleID: this.fieldsValues.id,
          permissions: [this.permissionSlug],
        });
        const selectedPermission = this.permissionsForSelect.find(
          item => item.prop === this.permissionSlug,
        );
        this.fieldsValues.permissions.push({
          slug: selectedPermission.prop,
          name: selectedPermission.displayText || selectedPermission.searchText,
        });
        this.permissionSlug = undefined;
        this.$toasted.success('Разрешение добавлено');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async removePermission(permission) {
      try {
        await this.deletePermissionFromRole({
          roleID: this.fieldsValues.id,
          permissions: [permission.slug],
        });
        this.fieldsValues.permissions = this.fieldsValues.permissions.filter(item => item.slug !== permission.slug);
        this.$toasted.success('Разрешение удалено');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
  },
  mounted() {
    if (this.$props.data && this.$props.data.id) {
      this.fieldsValues = this.$props.data;
      this.fieldsValues.permissions = this.fieldsValues.permissions.data;
    }
  },
}
</script>

<style>
.button--add {
  margin-top: 22px;
}

.role-permissions_list {
  max-height: 100px;
}
</style>